import { SPA_PATHS } from "@serophin/nottldr-shared/site";
import type { ComponentType } from "preact";
import { HomePage } from "./pages/HomePage";
import { NotFoundPage } from "./pages/NotFoundPage";
import { ArticlePage, ArticlesPage, AuthorArticlesPage, AuthorPage, AuthorsPage } from "./pages/publicPages";
import { CollectionsPage, FollowingPage, HistoryPage, ManageCollectionsPage, RecommendedPage, SettingsPage } from "./pages/signedInPages";
import {
  AboutPage,
  AuthConfirmDeletionPage,
  AuthMobilePage,
  AuthPage,
  AuthSignOutPage,
  AuthVerifyPage,
  EmailUnsubscribePage,
  FaqPage,
  PrivacyPage,
  TermsPage,
  TipPage,
} from "./pages/staticPages";

type Page = ComponentType<any>;

export type SiteRoute = {
  path: string;
  page: Page;
  kind: "public" | "spa";
  bare?: boolean;
};

export const SITE_ROUTES: SiteRoute[] = [
  { path: "/", page: HomePage, kind: "public" },
  { path: "/articles", page: ArticlesPage, kind: "public" },
  { path: "/authors", page: AuthorsPage, kind: "public" },
  { path: "/authors/:alias", page: AuthorPage, kind: "public" },
  { path: "/authors/:alias/articles", page: AuthorArticlesPage, kind: "public" },
  { path: "/about", page: AboutPage, kind: "public" },
  { path: "/faq", page: FaqPage, kind: "public" },
  { path: "/privacy", page: PrivacyPage, kind: "public" },
  { path: "/terms", page: TermsPage, kind: "public" },
  { path: "/tip", page: TipPage, kind: "public" },
  { path: "/auth", page: AuthPage, kind: "public" },
  { path: "/auth/verify", page: AuthVerifyPage, kind: "public" },
  { path: "/auth/confirm-deletion", page: AuthConfirmDeletionPage, kind: "public", bare: true },
  { path: "/auth/mobile", page: AuthMobilePage, kind: "public", bare: true },
  { path: "/auth/signout", page: AuthSignOutPage, kind: "public" },
  { path: "/email/unsubscribe", page: EmailUnsubscribePage, kind: "public" },
  { path: "/recommended", page: RecommendedPage, kind: "spa" },
  { path: "/collections", page: CollectionsPage, kind: "spa" },
  { path: "/collections/manage", page: ManageCollectionsPage, kind: "spa" },
  { path: "/profile", page: HistoryPage, kind: "spa" },
  { path: "/profile/following", page: FollowingPage, kind: "spa" },
  { path: "/profile/settings", page: SettingsPage, kind: "spa" },
  { path: "/:alias/:slug", page: ArticlePage, kind: "public" },
];

const spaRoutePaths = SITE_ROUTES.filter((route) => route.kind === "spa").map((route) => route.path);
if (spaRoutePaths.join() !== [...SPA_PATHS].join()) {
  throw new Error("SITE_ROUTES spa paths differ from SPA_PATHS in @serophin/nottldr-shared/site");
}

export const NOT_FOUND_PAGE: Page = NotFoundPage;

const BARE_PATHS = new Set(SITE_ROUTES.filter((route) => route.bare).map((route) => route.path));

export const isBarePath = (path: string, signedIn: boolean): boolean => BARE_PATHS.has(path) || (path === "/" && !signedIn);
